import { ref, type Ref, onMounted, onUnmounted } from 'vue'
import type { HblIUseModal } from '@/utils/types'

const modalState: Ref<boolean> = ref(false)
const modalContext: Ref<string> = ref('')
const modalData: Ref<any> = ref('')

export function useModal (): HblIUseModal {
    const toggleModal = (context: string, data: any, isSet?: boolean) => {
        if (data) {
            if (isSet === true) {
                modalData.value = { ...data, isSet: true }
            } else {
                modalData.value = data
            }
        }

        modalContext.value = modalContext.value === context ? '' : context
        modalState.value = !modalState.value
    }

    const closeModal = function () {
        modalState.value = false
        modalContext.value = ''
    }

    const handleEscKey = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            closeModal()
        }
    }

    onMounted(() => {
        if(modalState.value) {
            window.addEventListener('keyup', handleEscKey)
        }
    })

    onUnmounted(() => {
        window.removeEventListener('keyup', handleEscKey)
    })

    return {
        modalState,
        modalContext,
        modalData,
        toggleModal,
        closeModal
    }
}
